export default __webpack_public_path__ + "static/media/warpage_1.f497bc21.png";